import { WorkOrderChangeStatusProps } from 'constantsProject';
import { useRequest } from 'features/request/useRequest';
import { WorkOrderChangeStatusEnum } from 'gql/graphql';

import { useMemo } from 'react';

import { getWorkOrderChangeStatuses } from '../WorkOrderChangeQueries';

export const useWorkOrderChangeStatuses = ({
    currentStatus,
    isCreating,
}: {
    currentStatus: WorkOrderChangeStatusEnum | undefined;
    isCreating: boolean;
}) => {
    const [workOrderChangeStatuses] = useRequest({
        requestId: 'getWorkOrderChangeStatuses',
        query: getWorkOrderChangeStatuses,
        withEffect: !isCreating,
    });

    return useMemo(() => {
        if (isCreating || !currentStatus) {
            return [WorkOrderChangeStatusProps[WorkOrderChangeStatusEnum.OnFormation]];
        }

        const availableStatuses = workOrderChangeStatuses?.uerWorkOrderChangeStatuses?.data?.filter(
            (status) => status?.status === currentStatus,
        )?.[0]?.followers;

        const resultArr = availableStatuses?.length ? [...availableStatuses] : [];

        return resultArr.map((statusId) => WorkOrderChangeStatusProps[statusId]);
    }, [currentStatus, isCreating, workOrderChangeStatuses?.uerWorkOrderChangeStatuses?.data]);
};
